// Types
import { Icon as IconType } from '../../../types/icon';
import { Measurements } from '../../../types/measurements';

// Utils
import { getMeasurementBySize } from '../../../utils/icon';

// Component
import Icon from '../Icon/Icon';

const IconCloseEye = (props: IconType) => {
  const {
    size,
    inverse,
    onClick,
    width,
    height,
    fill,
    iconClassName,
  } = props;

  const defaultMeasurements: Measurements = {
    height: 24,
    width: 24,
  }

  const measurements = size ? getMeasurementBySize(size) : defaultMeasurements;

  return (
    <Icon inverse={inverse} onClick={onClick} className={iconClassName} classNameIconType="c-icon-close-eye">
      <svg
        className="c-icon-close-eye fill-current"
        width={width || measurements.width}
        height={height || measurements.height}
        viewBox="0 0 24 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M23.25 10.375C23.3625 10.15 23.3625 9.85 23.25 9.625C23.1 9.325 19.425 2.275 12 2.275C10.35 2.275 8.73752 2.65 7.23752 3.325C7.05002 3.4 6.90002 3.475 6.75002 3.5875L4.08752 0.925C3.75002 0.5875 3.22502 0.5875 2.88752 0.925C2.55002 1.2625 2.55002 1.7875 2.88752 2.125L19.875 19.075C20.025 19.225 20.25 19.3375 20.475 19.3375C20.7 19.3375 20.925 19.2625 21.075 19.075C21.4125 18.7375 21.4125 18.2125 21.075 17.875L18.7125 15.5125C18.75 15.475 18.75 15.475 18.7875 15.4375C21.75 13.3375 23.175 10.4875 23.25 10.375ZM13.4625 10.2625L11.7375 8.5375C11.8125 8.5375 11.925 8.5 12 8.5C12.825 8.5 13.5 9.175 13.5 10C13.5 10.075 13.4625 10.1875 13.4625 10.2625ZM14.775 11.575C14.8875 11.3875 14.9625 11.1625 15.0375 10.975C15.15 10.675 15.1875 10.3375 15.1875 10.0375C15.1875 8.275 13.7625 6.85 12 6.85C11.7375 6.85 11.4375 6.8875 11.175 6.9625L11.025 7C10.8 7.075 10.6125 7.15 10.3875 7.2625L7.95002 4.8625C9.22502 4.2625 10.5375 3.9625 11.925 3.9625C17.4 3.9625 20.625 8.65 21.45 10.0375C20.9625 10.825 19.725 12.7 17.7375 14.125C17.625 14.2 17.5125 14.275 17.4375 14.35L14.775 11.575Z" fill={fill || 'inherit'} />
        <path d="M12 16.075C6.52502 16.075 3.30002 11.3875 2.47502 10C2.85002 9.3625 3.71252 8.0875 5.02502 6.85005L3.86252 5.61255C1.83752 7.52505 0.787524 9.55 0.750024 9.625C0.637524 9.85 0.637524 10.15 0.750024 10.375C0.900024 10.675 4.57502 17.725 12 17.725C13.0125 17.725 14.025 17.575 15 17.3125L14.55 15.7C13.725 15.925 12.8625 16.075 12 16.075Z" fill={fill || 'inherit'} />
      </svg>
    </Icon>
  );
};

export default IconCloseEye;
